<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-prospect-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>บันทึกรายการติดต่อสอบถาม</span>
                        </h4>

                        <button class="btn-close" @click="hide(false)"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form" v-if="formData && errorData">
                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <label>ชื่อ-นามสกุล</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.customer.blank }"
                                                maxlength="100"
                                                placeholder="ผู้มาติดต่อ"
                                                v-model="formData.customer" />
                                        <div class="input-error-message" v-if="errorData.customer.blank">โปรดกรอกชื่อผู้ติดต่อ</div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="field">
                                        <label>เบอร์ติดต่อ</label>
                                        <input type="tel" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.tel.blank }"
                                                maxlength="20"
                                                placeholder="เบอร์ติดต่อ"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.tel" />
                                        <div class="input-error-message" v-if="errorData.tel.blank">โปรดกรอกเบอร์ติดต่อ</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6">
                                    <div class="field">
                                        <label>ทะเบียนรถ</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.licensePlate.blank }"
                                                maxlength="10"
                                                placeholder="ทะเบียนรถ"
                                                v-model="formData.licensePlate" />
                                        <div class="input-error-message" v-if="errorData.licensePlate.blank">โปรดกรอกทะเบียนรถ</div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="field">
                                        <label>ทะเบียนจังหวัด</label>
                                        <dropdown
                                            v-model="formData.licensePlateProvince"
                                            placeholder="-- เลือกจังหวัด --"
                                            :options="option.licensePlateProvince"
                                            :classes="{ input: ['input-field', (errorData.licensePlateProvince.blank ? 'invalid' : '')] }"
                                        ></dropdown>
                                        <div class="input-error-message" v-if="errorData.licensePlateProvince.blank">โปรดเลือกทะเบียนจังหวัด</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-4">
                                    <div class="field">
                                        <label>ยี่ห้อรถ</label>
                                        <dropdown
                                            v-model="formData.carBrand"
                                            placeholder="ยี่ห้อรถ"
                                            :options="option.carBrand"
                                            :classes="{ input: ['input-field', (errorData.carBrand.blank ? 'invalid' : '')] }"
                                            @change="loadCarModel($event)"
                                        ></dropdown>
                                        <div class="input-error-message" v-if="errorData.carBrand.blank">โปรดเลือกยี่ห้อรถ</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <div class="field">
                                        <label>รุ่นรถ</label>
                                        <dropdown
                                            v-model="formData.carModel"
                                            placeholder="รุ่นรถ"
                                            :options="option.carModel"
                                            :classes="{ input: ['input-field', (errorData.carModel.blank ? 'invalid' : '')] }"
                                            @change="loadCarYearSerie($event)"
                                        ></dropdown>
                                        <div class="input-error-message" v-if="errorData.carModel.blank">โปรดเลือกรุ่นรถ</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <div class="field">
                                        <label class="optional">ปีรถ</label>
                                        <dropdown
                                            v-model="formData.carYearSerie"
                                            placeholder="ปีรถ"
                                            :options="option.carYearSerie"
                                            :classes="{ input: 'input-field' }"
                                        ></dropdown>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <label>สอบถามเรื่อง</label>
                                        <dropdown
                                            v-model="formData.topic"
                                            placeholder="-- เลือกหัวข้อ --"
                                            :options="option.topic"
                                            :classes="{ input: ['input-field', (errorData.topic.blank ? 'invalid' : '')] }"
                                        ></dropdown>
                                        <div class="input-error-message" v-if="errorData.topic.blank">โปรดเลือกหัวข้อสอบถาม</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="field">
                                        <label class="optional">ข้อมูลเพิ่มเติม</label>
                                        <input type="text" 
                                                class="input-field"
                                                maxlength="500"
                                                placeholder="ข้อมูลเพิ่มเติม"
                                                v-model="formData.detail" />
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-right">
                                <button class="btn btn-main" @click="saveProspect()">บันทึก</button>
                                <button class="btn btn-grey-outline" @click="hide(false)">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import DBProspect from '@/database/Prospect';
import OptionProspectTopic from '@/database/staticOption/ProspectTopic';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';

export default {
    data() {
        return {
            isActive: false,
            formData: null,
            errorData: null,
            option: {
                licensePlateProvince: [],
                carBrand: [],
                carModel: [],
                carYearSerie: [],
                topic: [],
            }
        };
    },
    props: {
        isDisplay: Boolean,
        keyData: [Number, String]
    },
    mounted() {
        this.initOptionData();
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.formData = await this.initFormData();
                this.errorData = this.initValidateData();
            }
        }
    },
    methods: {
        hide(isReload) {
            this.$emit('hide', isReload);
        },
        async initFormData() {
            return {
                key: '',
                date: '',
                customer: '',
                tel: '',
                licensePlate: '',
                licensePlateProvince: '',
                carBrand: '',
                carModel: '',
                carYearSerie: '',
                topic: '',
                detail: ''
            }
        },
        async initOptionData() {
            this.option.licensePlateProvince = OptionLicensePlateProvince.option;

            this.option.carBrand = await this.$AppUtility.setupCarBrandOption();
            this.option.carModel = [];
            this.option.carYearSerie = [];

            this.option.topic = OptionProspectTopic.option;
        },
        initValidateData() {
            return {
                customer: { blank: false },
                tel: { blank: false },
                licensePlate: { blank: false },
                licensePlateProvince: { blank: false },
                carBrand: { blank: false },
                carModel: { blank: false },
                topic: { blank: false }
            }
        },
        async loadCarModel(value) {
            if (value) {
                const param = {
                    carBrand: value
                };

                this.option.carModel = await this.$AppUtility.setupCarModelOption(param);
            } else {
                this.option.carModel = [];
                this.option.carYearSerie = [];
                this.formData.carModel = '';
                this.formData.carYearSerie = '';
            }
        },
        async loadCarYearSerie(value) {
            if (value) {
                const param = { 
                    carBrand: this.formData.carBrand,
                    carModel: value
                };

                this.option.carYearSerie = await this.$AppUtility.setupCarYearSerieOption(param);
            } else {
                this.option.carYearSerie = [];
                this.formData.carYearSerie = '';

            }
        },
        async saveProspect() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                this.formData.date = new Date();

                await DBProspect.save(this.formData);

                this.hide(true);
                loader.hide();
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (!this.formData[property].trim()) {
                    this.errorData[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-prospect-form {
    max-width: 800px;
}
</style>